import { Fragment, useEffect, useState } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ArrowDownIcon } from '@heroicons/react/solid'

export default function ListBox2({
    options,
    className,
    onSelect,
    valueFromParent,
    Icon,
    placeholder = 'Select an option',
}) {
    const [selected, setSelected] = useState([])

    const handleSelect = (option) => {
        let newSelected
        if (selected.includes(option)) {
            newSelected = selected.filter((item) => item !== option) // Deselect item if already selected
        } else {
            newSelected = [...selected, option] // Add item if not selected
        }
        setSelected(newSelected)
        onSelect(newSelected)
    }

    useEffect(() => {
        if (valueFromParent) {
            setSelected(valueFromParent)
        }
    }, [valueFromParent])

    return (
        <Listbox value={selected} onChange={handleSelect}>
            <div className="relative">
                <Listbox.Button
                    className={`relative w-full text-white text-xl cursor-default rounded-lg bg-olh py-2 pl-3 pr-10 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-md ${className}`}>
                    <div className="truncate block">
                        <span>
                            {selected.length > 0 ? (
                                selected.map((item) => item.name).join(', ')
                            ) : (
                                <div className="flex space-x-2 items-center">
                                    <Icon className="h-5 w-5 text-white text-xl" />
                                    <span>{placeholder}</span>
                                </div>
                            )}
                        </span>
                    </div>
                    <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                        <ArrowDownIcon
                            className="h-5 w-5 text-white text-xl"
                            aria-hidden="true"
                        />
                    </span>
                </Listbox.Button>
                <Transition
                    as={Fragment}
                    leave="transition ease-in duration-100 overflow-visible"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0">
                    <Listbox.Options className="absolute mt-1 min-w-[300px] z-50  text-xl max-h-60 w-full overflow-auto rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
                        {options.map((option, personIdx) => (
                            <Listbox.Option
                                key={personIdx}
                                className={({ active }) =>
                                    `relative cursor-default select-none py-2 pl-10 pr-4 ${
                                        active
                                            ? 'bg-gray-100 text-black'
                                            : 'text-gray-900'
                                    }`
                                }
                                value={option}>
                                {() => (
                                    <>
                                        <span
                                            className={`block truncate ${
                                                selected.includes(option)
                                                    ? 'font-medium'
                                                    : 'font-normal'
                                            }`}>
                                            {option.name}
                                        </span>
                                        {selected.includes(option) ? (
                                            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                <CheckIcon
                                                    className="h-5 w-5"
                                                    aria-hidden="true"
                                                />
                                            </span>
                                        ) : null}
                                    </>
                                )}
                            </Listbox.Option>
                        ))}
                    </Listbox.Options>
                </Transition>
            </div>
        </Listbox>
    )
}
